import pinia from '@/plugins/pinia';
import i18n from '@/plugins/vue-i18n';

const plugins = [
  pinia,
  i18n
];

export default plugins;
